<template>
  <div class="page v-service-switch">
    <div style="background: white; padding: 0.2rem;">
      <div class="change-title">转入金额</div>
      <div class="change-box">
        <div class="icon v-center">¥</div>
        <div class="flex">
          <input type="number"
                 :class="{'number':money > 0 || money.length > 0}"
                 v-model="money"
                 placeholder="请输入金额">
        </div>
        <div class="icon v-center"
             @click="money = ''">
          <img src="@/assets/img/del-input.png"
               alt=""
               v-show="money>0">
        </div>
      </div>
      <van-divider :style="{ borderColor: '#dcdcdc', margin: '0 0', padding: '0 0' }"/>
      <div class="change-title">请选择账户</div>
      <van-radio-group v-model="radio">
        <van-radio name="1" icon-size="0.34rem" checked-color="#14CC80">中国普天新能源有限公司</van-radio>
        <van-radio name="2" icon-size="0.34rem" checked-color="#14CC80">香洲区充电桩有限公司</van-radio>
      </van-radio-group>
    </div>
    <div class="button1" @click="showTipDialog = true">转入</div>
    <van-popup v-model="showTipDialog"  :style="{ height: '2.58rem', padding: '0.2rem 0.2rem', 'box-sizing':'border-box','margin-top': '0'}">
      <div class="tip-container">
        <div class="tip-title">提示</div>
        <!--<div class="tip-content">转入金额失败!<br>所选账户余额不足!</div>-->
        <div class="tip-content">成功转入金额<span style="color: #14CC80">200</span>元!<br>当前账户余额为200.00！</div>
      </div>
      <van-icon name="cross" color="#999999" style="position: absolute; right: 0.1rem; top: 0.1rem" @click="showTipDialog = !showTipDialog"/>
    </van-popup>
  </div>
</template>

<script>
import { Divider, RadioGroup, Radio, Popup, Icon } from 'vant';

export default {
  name: 'change-money',
  components: {
    [Divider.name]: Divider,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Popup.name]: Popup,
    [Icon.name]: Icon
  },
  data () {
    return {
      money: 19,
      radio: '1',
      showTipDialog: false
    };
  },
  methods: {}
};
</script>

<style lang="less" scoped>
@import "../../assets/less/old/var.less";

.page {
  height: 100%;
  background: #F4F4F4;
  .change-title {
    margin-top: 0.2rem;
    .size;
    color: #666666;
  }
  .change-box {
    display: flex;
    margin-top: 0.1rem;
    border-bottom: @border;
    .icon {
      font-size: 0.6rem;
      color: @black;
      img {
        width: 0.44rem;
        margin-top: 0.18rem;
        vertical-align: top;
      }
    }
    .flex {
      flex: 1;
      padding-left: 0.1rem;
      padding-top: 0.03rem;
      input {
        font-size: 0.32rem;
        line-height: 0.84rem;
        font-weight: bold;
        width: 100%;
      }
      input.number {
        font-size: 0.6rem;
      }
    }
  }
  .tip-container {
    width: 5.21rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    color: #333333;
    .tip-title {
      font-size: 0.36rem;

    }
    .tip-content {
      font-size: 0.28rem;
      margin-top: 0.2rem;
      line-height: 0.4rem;
      text-align: center;
    }
  }
}
</style>
